<template lang="pug">
.nav-icon(:class="{ active: mobileMenuVisible }" @click="toggleMenu")
  span(v-for="line in [1,2,3,4]" :key="line")
</template>
<script>
export default {
  data: () => ({
    mobileMenuVisible: false
  }),
  methods: {
    hideMenu() {
      this.mobileMenuVisible = false
    },
    toggleMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
      if (this.mobileMenuVisible) {
        this.$emit('show')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/MobileIcon.vue